import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import {
  deleteSupportServices,
  getSupportServicesList,
} from 'app/api/supportservices';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
const useMallSupportService = () => {
  const [isdeleteFiltering, setIsdeleteFiltering] = useState(false); // New state to track filtering

  const navigate = useNavigate();
  const sectionObj = {
    sectionTitle: 'Mall Support Service',
    searchObj: {
      keys: ['serviceName', 'mallName', 'contactNumber'],
      placeholder: 'Search by Name, Mall Name, Contact No.',
      searchType: 'server',
      handleSearch: (e) => {
        console.log('Handle search: ', e);
      },
    },
    buttons: [
      {
        customclassName: '',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_SUPPORT_SERVICE_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_SUPPORT_SERVICE}`);
        },
      },
    ],
  };
  const [pageCount, setPageCount] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const currentPage = 1;
  const dataPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);
  const [totalNumber, setTotalNumber] = useState(0);

  const fetchMallServiceData = useCallback(
    async (page, search = '') => {
      setPageLoading(true);
      try {
        const response = await getSupportServicesList({
          page,
          limit: dataPerPage,
          search,
        });
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.data || [];
          const newArray = dataArr.map((item) => ({
            ...item,
            serviceName: item?.serviceId?.serviceName,
            mallName: item?.mallId?.mallName,
          }));
          setFilteredData(newArray);
          const totalCount = response?.data?.count || 0;
          setTotalNumber(totalCount);
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setPageCount(tempcount);
          setIsdeleteFiltering(false);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );

  async function deleteSevice(data) {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteSupportServices(data?.id);
      setPageLoading(false);
      setIsdeleteFiltering(true);
      if (responseObj?.responseCode === 200) {
        Toast.success('Service Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : Message.Error.COMMON_MESSAGE
        );
      }
    }
  }
  function handleDelete(data) {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete ${data?.serviceId?.serviceName} this Service?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            deleteSevice(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  }
  function handleEdit(data) {
    navigate(`/mall-support-service/edit/:${data.id}`, {
      state: {
        ...data,
      },
    });
  }
  return {
    handleDelete,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    navigate,
    handleEdit,
    totalNumber,
    sectionObj,
    filteredData,
    fetchMallServiceData,
    isdeleteFiltering,
  };
};

export default useMallSupportService;
